export default __webpack_public_path__ + "static/media/otherJewelry.1a01207d.webp";